// extracted by mini-css-extract-plugin
export default {"logo":"profile_logo__A4IcU","avatarBtn":"profile_avatarBtn__s7psS","menu":"profile_menu__jqhY6"};